import styled from 'styled-components'

import { Colors } from '@/theme/defaults'

import { DividerOrientationKeys, DividerTextAlignKeys, DividerVariantKeys } from './divider.types'

interface StyledDividerProps {
  $orientation: DividerOrientationKeys
  $variant: DividerVariantKeys
  $flexItem: boolean
  $light: boolean
  $color?: keyof Colors
  $hasChildren: boolean
  $textAlign: DividerTextAlignKeys
}

export const Root = styled.div<StyledDividerProps>(
  ({ theme, $orientation, $variant, $flexItem, $light, $color, $hasChildren, $textAlign }) => {
    const color = $color
      ? theme.colors[$color]
      : $light
        ? theme.colors.gray200
        : theme.colors.gray300
    const line = `${theme.border.size['1']} solid ${color}`

    if ($orientation === 'vertical') {
      const marginMap = {
        fullWidth: { margin: 0 },
        inset: { marginTop: theme.space['8'] },
        middle: { margin: `${theme.space['8']} 0` },
      }
      return {
        alignSelf: $flexItem ? 'stretch' : undefined,
        borderLeft: line,
        display: $flexItem ? 'inline-flex' : 'inline-block',
        height: $flexItem ? 'auto' : '100%',
        width: 0,
        ...marginMap[$variant],
      }
    }

    const marginMap = {
      fullWidth: { margin: 0 },
      inset: { marginLeft: theme.space['16'] },
      middle: { margin: `0 ${theme.space['16']}` },
    }

    if ($hasChildren) {
      return {
        '&::after': {
          borderTop: line,
          content: '""',
          flex: $textAlign === 'right' ? '0 0 1.6rem' : 1,
        },
        '&::before': {
          borderTop: line,
          content: '""',
          flex: $textAlign === 'left' ? '0 0 1.6rem' : 1,
        },
        alignItems: 'center',
        color,
        display: 'flex',
        fontSize: '1.2rem',
        fontWeight: 500,
        gap: theme.space['8'],
        width: '100%',
        ...marginMap[$variant],
      }
    }

    return {
      border: 'none',
      borderTop: line,
      height: 0,
      width: '100%',
      ...marginMap[$variant],
    }
  },
)
